import React from 'react'

export const SiteLogoName = ({ site }) => (
    <span title={site.name} style={{ display: 'flex', alignItems: 'center', maxWidth: '70vw', overflow: 'hidden' }}>
        <img className="site-logo-big" alt='' src={site.logoURL} />
        &nbsp;
        <span className="site-logo-name-text">{site.name}</span>
    </span>
)
